import React, { useState, useEffect } from "react";
import CalendarDatePicker from "../../componenents/CalendarDatePicker";
import { getCareNavigators, fetch_supervisors_list, carenavigatorFutureAppointmentsDataPoints, carenavigatorFutureAppointmentsList } from "../../../services/medengage/Service";
import moment from "moment";
import { exportTableData } from "../../utils/CommonLibrary";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import CallCompetionRatesBar from "../../componenents/DashboardGraphsCNP/CallCompetionRatesBar";
import MemberPathwayStatusPie from "../../componenents/DashboardGraphs/MemberPathwayStatusPie";
import { decryptData } from "../../utils/Utils";
import { MultiSelect } from 'react-multi-select-component';
import CareNavigatorAppointmentsList from "./CareNavigatorAppointmentsList";
import CNAppointmentsBookedBy from "../../componenents/DashboardGraphs/CNAppointmentsBookedBy";
import CNAppointmentCallStatus from "../../componenents/DashboardGraphs/CNAppointmentCallStatus";
import { CustomLoader } from '../../utils/CommonLibrary';
import BackendDrivenDataTable from '../../cn/components/common/BackendDrivenDataTable';
import { toast } from "react-toastify";
import { NotificationToast } from "../../componenents/ContentCareNavigator/NotificationToast";
import './CareNavigatorAppointments.css';


function FutureAppointments() {

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    const formattedYesterdayDate = yesterday.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });


    const storedDates = localStorage.getItem('selectedDates') ? JSON.parse(decryptData(localStorage.getItem('selectedDates'))) : '';

    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment().add(7, 'days'));

    const resetTime = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    /*const [isWithinRange, setIsWithinRange] = useState(false);
    useEffect(() => {
        const today = resetTime(new Date());
        const sd = resetTime(new Date(startDate));
        const ed = resetTime(new Date(endDate));

        console.log(today, sd, ed);

        let iwr = today >= sd && today <= ed;
        setIsWithinRange(iwr);
    }, [startDate, endDate])*/

    const [searchQuery, setSearchQuery] = useState('');
    const [selectedCN, setSelectedCN] = useState("");
    const [selectedSupervisor, setSelectedSupervisor] = useState("");
    const [carenavigatorsList, setCarenavigatorsList] = useState([]);
    const [supervisorList, setSupervisorList] = useState([]);
    const [navigatorStats, setNavigatorStats] = useState({
        totalSlots: 0,
        appointmentsScheduled: 0,
        newAppointments: 0,
        followupAppointments: 0
    });
    const [options, setOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);

    const [loading, setLoading] = useState(true);
    const [seriesGraph, setSeriesGraph] = useState({
        bookedBy: [],
        callStatus: []
    })


    const [selectedProgram, setSelectedProgram] = useState('');
    const [selectedCondition, setSelectedCondition] = useState('');
    const [programList, setProgramList] = useState([]);
    const [conditionList, setConditionList] = useState([]);
    const [newMembersDisenrollList, setNewMembersDisenrollList] = useState([])
    const [data, setData] = useState([]);
    const [isNewLoading, setIsNewLoading] = useState(false);

    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState("actualDate");
    const [sortDirection, setSortDirection] = useState('asc');
    const [download, setDownload] = useState('N');


    useEffect(() => {
        fetchListDetails();
    }, [page, perPage, sortColumn, sortDirection, startDate, endDate, selectedCN, selectedSupervisor, download]);

    const fetchListDetails = async () => {
        try {
            setIsNewLoading(true);
            carenavigatorFutureAppointmentsList(formatDate(startDate), formatDate(endDate), selectedCN, selectedSupervisor,
                page, perPage, sortColumn, sortDirection, download)
                .then((response) => {
                    if (response.data.code == 200) {
                        if (download == "N") {
                            setData(response.data.data.logs);
                            setTotalRows(response.data.data.totalRows);
                        } else {
                            if (response.data.data.status == 1) {
                                toast.success(response.data.data.msg, {
                                    position: 'top-right'
                                })
                            } else {
                                toast.error(response.data.data.msg, {
                                    position: 'top-right'
                                })
                            }
                            setDownload('N');
                        }
                    }

                });
        } catch (error) {
            console.error(error);
        }
        finally {
            setIsNewLoading(false);
        }
    };

    const handleChange = (selected) => {
        setSelectedOptions(selected);
        const valueArray = selected.map(option => option.value).join(',')

        setSelectedCN(valueArray);
    };
    useEffect(() => {
        const performFilterEffect = async () => {
            setLoading(true);
            await filterData();
        };

        performFilterEffect();
    }, [startDate, endDate, selectedCN, selectedSupervisor]);

    useEffect(() => {
        getCareNavigatorsList();
    }, [selectedSupervisor])
    useEffect(() => {
        fetchSuperisorsList();
    }, []);

    const getCareNavigatorsList = async () => {
        setOptions([]);
        setSelectedOptions([])
        await getCareNavigators(selectedSupervisor)
            .then((response) => {
                if (response.data.code === 200) {
                    const carenavigators = response.data.data.users;
                    setCarenavigatorsList(carenavigators);
                    const formattedOptions = carenavigators.map((item) => ({
                        label: item.userName,
                        value: item.id
                    }));
                    setOptions(formattedOptions);
                }
            }).catch(function (error) {
                console.log(error);
            });
    };

    const fetchSuperisorsList = async () => {
        await fetch_supervisors_list()
            .then((res) => {
                setSupervisorList(res.data.data.supervisors);
            });
    }

    const filterData = async () => {
        await fetchData();
        setLoading(false);
    };

    const fetchData = async () => {
        carenavigatorFutureAppointmentsDataPoints(formatDate(startDate), formatDate(endDate), selectedCN, selectedSupervisor)
            .then((response) => {
                setNavigatorStats(prevState => ({
                    ...prevState, totalSlots: response.data.data.totalSlots, appointmentsScheduled: response.data.data.appointmentsScheduled, newAppointments: response.data.data.newAppointments, followupAppointments: response.data.data.followupAppointments
                }));
            });
    }



    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const handleDateChange = ({ start, end }) => {
        setStartDate(start);
        setEndDate(end);
    };

    const renderToolTip1 = (props) => (
        <Tooltip className="custom-tooltip" {...props}>
            Total number of available and booked appointment slots.
        </Tooltip>
    );

    const renderToolTip2 = (props) => (
        <Tooltip className="custom-tooltip" {...props}>
            Total number of appointments scheduled.
        </Tooltip>
    );

    const renderToolTip3 = (props) => (
        <Tooltip className="custom-tooltip" {...props}>
            Number of appointments marked as New Appointments.
        </Tooltip>
    );

    const renderToolTip4 = (props) => (
        <Tooltip className="custom-tooltip" {...props}>
            Number of appointments marked as Follow-up Appointments.
        </Tooltip>
    );

    const renderToolTip5 = (props) => (
        <Tooltip className="custom-tooltip" {...props}>
            Distribution of appointment status
        </Tooltip>
    );

    const columns = [
        {
            name: 'Date',
            selector: row => row.actualDate,
            format: row => row.actualDate,
            sortable: true,
        },
        {
            name: 'CareNavigator Name',
            selector: row => row.cnName,
            sortable: true,
        },
        {
            name: 'Supervisor',
            selector: row => row.supervisorName,
            sortable: true,
        },
        {
            name: 'Total Slots',
            selector: row => row.totalSlots,
            sortable: false,
        },
        {
            name: 'Scheduled Appointments',
            selector: row => row.scheduledAppointments,
            sortable: false,
        },
        {
            name: 'New Appointments',
            selector: row => row.newAppointments,
            sortable: false,
        },
        {
            name: 'Followup Appointments',
            selector: row => row.followAppointments,
            sortable: false,
        },
        {
            name: 'Break Information',
            selector: row => row.breakInfo,
            sortable: false,
        }
    ];

    const handleClear = () => {
        setSelectedCN("");
        setSelectedSupervisor("");
    };

    return (
        <>
            <NotificationToast />
            <div className="container-fluid">
                <div className="row align-items-center mb-3">
                    <div className="col-md-3 pe-0">
                        <select className="form-select input-field-ui" id="selectedSupervisor" aria-label="Default select example" value={selectedSupervisor} onChange={(e) => setSelectedSupervisor(e.target.value)}>
                            <option value="">Select Supervisor</option>
                            {supervisorList.map(option => (
                                <option key={option.id} value={option.id}>{option.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-3 px-1">
                        <MultiSelect
                            options={options}
                            value={selectedOptions}
                            onChange={handleChange}
                            labelledBy="Select"
                            hasSelectAll={false}
                            className="form-select select-input-ui select-input-ui-select"
                            disableSearch={true}
                            overrideStrings={{ selectAll: 'Select All', allItemsAreSelected: 'All items are selected', selectSomeItems: 'Select CareNavigators' }}
                            style={{ fontSize: '1rem' }}

                        />
                    </div>

                    <div className="col-md-3 ps-0">
                        <CalendarDatePicker startDate={startDate} endDate={endDate} onDateChange={handleDateChange} minDate={new Date()} maxDate={moment().add(90, 'days')} />
                    </div>
                    <div className='col-md-auto px-1'>
                        <button onClick={handleClear} className='btn btn-primary btn-primary clear-search-btn'>Clear</button>
                    </div>
                    <div className='col-md-auto px-1'>
                        <button onClick={() => setDownload('Y')} className="btn btn-primary btn-primary clear-search-btn"><i className="bi bi-download"></i> Export</button>
                    </div>
                </div>



                <div className="content-ProgramPerformance mb-3">
                    <div className="row text-center px-2">
                        <div className="col px-1" >
                            <div className={`card bg-grey`} style={{ borderRadius: '14px', border: 'none', height: "100%" }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="card-title1">{navigatorStats.totalSlots}</h1>
                                            <h5 className="card-text1">Total Slots
                                                <OverlayTrigger placement="top" overlay={renderToolTip1}>
                                                    <i className='bx bx-info-circle ms-1'></i>
                                                </OverlayTrigger>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col px-1" >
                            <div className={`card bg-grey`} style={{ borderRadius: '14px', border: 'none', height: "100%" }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="card-title1">{navigatorStats.appointmentsScheduled}</h1>
                                            <h5 className="card-text1">Appointments Scheduled
                                                <OverlayTrigger placement="top" overlay={renderToolTip2}>
                                                    <i className='bx bx-info-circle ms-1'></i>
                                                </OverlayTrigger>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col px-1" >
                            <div className={`card bg-grey`} style={{ borderRadius: '14px', border: 'none', height: "100%" }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="card-title1">{navigatorStats.newAppointments}</h1>
                                            <h5 className="card-text1">New Appointments
                                                <OverlayTrigger placement="top" overlay={renderToolTip3}>
                                                    <i className='bx bx-info-circle ms-1'></i>
                                                </OverlayTrigger>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col px-1" >
                            <div className={`card bg-grey`} style={{ borderRadius: '14px', border: 'none', height: "100%" }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="card-title1">{navigatorStats.followupAppointments}</h1>
                                            <h5 className="card-text1">Follow-up Appointments
                                                <OverlayTrigger placement="top" overlay={renderToolTip4}>
                                                    <i className='bx bx-info-circle ms-1'></i>
                                                </OverlayTrigger>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div className='content-CareNavigatorPerformance'>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="table-responsive CareNavigatorAppointmentsList">
                                {
                                    isNewLoading ? <CustomLoader /> :
                                        <BackendDrivenDataTable
                                            data={data}
                                            loading={isNewLoading}
                                            totalRows={totalRows}
                                            page={page}
                                            perPage={perPage}
                                            sortColumn={sortColumn}
                                            sortDirection={sortDirection}
                                            filterText={searchQuery}
                                            columns={columns}
                                            fetchTableData={fetchListDetails}
                                            setPage={setPage}
                                            setSortColumn={setSortColumn}
                                            setSortDirection={setSortDirection}
                                            setPerPage={setPerPage}
                                        />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FutureAppointments